import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { GenericInformation } from '../models/generic-information.interface';
import { BaseResponse } from '../models/base-response.interface';
import { map } from 'rxjs/operators';
import { ScriptLoaderService } from './script-loader.service';


@Injectable({
    providedIn: 'root'
})
export class PaymentGatewayService {
    private culqiInstance: any;
    private scriptLoader = inject(ScriptLoaderService);

    async initialize(publicKey: string, settings: any, client: any, options: any, appearance: any): Promise<void> {
        console.log('PaymentGatewayService-initialize');
        await this.scriptLoader.loadScript('https://js.culqi.com/checkout-js');
        await this.waitForCulqiCheckout();
        console.log('PaymentGatewayService-initialize 2');
        const config = {
            settings,
            client,
            options,
            appearance,
        };

        const CulqiCheckout = (window as any).CulqiCheckout;
        if (typeof CulqiCheckout !== 'function') {
            throw new Error('CulqiCheckout no está disponible aún');
        }

        // @ts-ignore
        this.culqiInstance = new window.CulqiCheckout(publicKey, config);

        console.log('this.culqiInstance', this.culqiInstance);

        // Callback
        this.culqiInstance.culqi = this.handleCulqiResponse;
    }

    openCheckout(): void {
        if (this.culqiInstance) {
            this.culqiInstance.open();
        }
    }

    private handleCulqiResponse(): void {
        console.log('Error', window.Culqi.error);
        // @ts-ignore
        if (window.Culqi.token) {
            console.log('Token generado:', window.Culqi.token.id);
        } else if (Culqi.order) {
            console.log('Order generado:', window.Culqi.order);
        } else {
            console.error('Error Culqi:', window.Culqi.error);
        }
    }

    private waitForCulqiCheckout(retries = 10, delay = 500): Promise<void> {
        return new Promise((resolve, reject) => {
            const check = () => {
                const CulqiCheckout = (window as any).CulqiCheckout;
                if (typeof CulqiCheckout === 'function') {
                    resolve();
                } else if (retries === 0) {
                    reject(new Error('CulqiCheckout no está disponible aún'));
                } else {
                    retries--;
                    setTimeout(check, delay);
                }
            };
            check();
        });
    }
} 